import { render, staticRenderFns } from "./customerTwo.vue?vue&type=template&id=d8b4cd38&scoped=true&"
import script from "./customerTwo.vue?vue&type=script&lang=js&"
export * from "./customerTwo.vue?vue&type=script&lang=js&"
import style0 from "./customerTwo.vue?vue&type=style&index=0&id=d8b4cd38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b4cd38",
  null
  
)

export default component.exports